import { render, staticRenderFns } from "./SearchNavItemFieldSelect.vue?vue&type=template&id=6b1d61f0&scoped=true"
import script from "./SearchNavItemFieldSelect.vue?vue&type=script&lang=js"
export * from "./SearchNavItemFieldSelect.vue?vue&type=script&lang=js"
import style0 from "./SearchNavItemFieldSelect.vue?vue&type=style&index=0&id=6b1d61f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1d61f0",
  null
  
)

export default component.exports